import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { lockBody, unlockBody, debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)
var iso = ''

const parent = $('.pt-locations__posts')
if (parent.length) {
  iso = new Isotope('.pt-locations__posts', {
    itemSelector: '.feed-boat-js',
    percentPosition: true,
    masonry: {
      columnWidth: '.pt-locations__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })
}

const input = $('.pt-locations .filters input')

input.on('change', function () {
  const input = $(this)

  // Post types.
  const boat = $('input[name="boat"]').is(':checked')
  const js = $('input[name="jet-ski"]').is(':checked')

  // Features.
  const feature =  $('input[name="feature"]:checked').val()

  // Terms.
  const capacity = $('input[name="capacity"]:checked').val() * 1
  const motor = $('input[name="motor"]:checked').val() * 1
  const boatType = $('input[name="boat-type"]:checked').val() * 1

  if (!input.is(':checked')) {
    // iso.arrange({ filter: '*' })
    // return
  }

  iso.arrange({
    filter: function () {
      const post = $(this)

      if (post.hasClass('pt-locations__sizer')) {
        return false
      }

      let capsMatched = true
      let caps = post.attr('data-capacities')
      if (capacity) {
        if ( capacity > caps ) {
          capsMatched = false
        }
      }

      let motorsMatched = true
      let motors = post.attr('data-motors')
      motors = motors.includes(',') ? motors.split(',') : [motors]
      motors = motors.map(Number)
      if (motor) {
        motorsMatched = motors.includes(motor)
      }

      let boatTypesMatched = true
      let boatTypes = post.attr('data-boat-type')
      boatTypes = boatTypes.includes(',') ? boatTypes.split(',') : [boatTypes]
      boatTypes = boatTypes.map(Number)
      if (boatType && $('.js-boat-only').css('display') != 'none') {
        boatTypesMatched = boatTypes.includes(boatType)
      }

      let featuresMatched = true
      let features = post.attr('data-features')
      features = features.includes(',') ? features.split(',') : [features]
      if (feature === 'license') {
        featuresMatched = features.includes('license')
      }
      if (feature === 'no-license') {
        featuresMatched = features.includes('no-license')
      }

      let postTypeMatched = true
      let postType = post.attr('data-post-type')

      if (js) {
        postTypeMatched = postType === 'jet-ski'
      }
      if (boat && js) {
        postTypeMatched = true
      }

      return (
        capsMatched &&
        motorsMatched &&
        featuresMatched &&
        postTypeMatched &&
        boatTypesMatched
      )
    },
  })
})

/*const search = $('.pt-locations .filters input[type="search"]').keyup(
  debounce(function () {
    const qsRegex = new RegExp(search.val(), 'gi')

    iso.arrange({
      filter: function () {
        const post = $(this)
        const text = getTextNodesIn(post[0])

        return qsRegex ? text.match(qsRegex) : true
      },
    })
  }, 200)
)

search.on('blur', function() {
  const qsRegex = new RegExp(search.val(), 'gi');

  iso.arrange({
    filter: function () {
      const post = $(this);
      const text = getTextNodesIn(post[0]);

      return qsRegex ? text.match(qsRegex) : true;
    },
  })
})*/
